export default "__VITE_ASSET__CT_6ZBec__"